module.exports = __webpack_public_path__ + "img/booking_clash_black_icon.7e247a7d.svg";